/**
 * This is the memword data service.
 * @memberOf memword Module
 * @namespace memword Data Service
 */

/**
 * @name memwordDataService
 * @desc Create the data service.
 * @param $q
 * @param $http
 * @param coreService
 * @memberOf memword Module.memword Data Service
 * @ngInject
 */
var memwordDataFactory = function ($q, $http, coreService) {
    // Create the service.
    var service = { };

    service.updateReminder = function (productLanguage) {
        var model = coreService.getIdentityModel();

        $http.get(model.siteUrl + "selfService/Reminders?languageId=" + productLanguage.productLanguageId)
            .then(function(response) {
                model.word_reminder = response.data.reminderText;
            });
    }

    return service;

}

export default memwordDataFactory;



// WEBPACK FOOTER //
// ./src/login/memword/memword.data.service.js